import FileApi from '@/apis/FileApi';
import BaseStore from './BaseStore';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import { BodyGetInvoices, File, GetInvoicesResponse } from '@/types/files';
import { ResponseData } from '@/types/http';
export default class FileStore extends BaseStore {
    api: FileApi;
    listInvoices: File[] = [];
    keepSearchParams: BodyGetInvoices = {} as BodyGetInvoices;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            keepSearchParams: observable,
            listInvoices: observable,
            getListInvoices: flow.bound,
            getDetailInvoice: flow.bound,
            checkInvoiceStatus: flow.bound
        });
        this.api = new FileApi();
    }

    *getListInvoices(payload) {
        try {
            const res: ResponseData<GetInvoicesResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getInvoices, payload);
            if (res?.ok) {
                this.listInvoices = res.data.elements;
                this.paging = {
                    ...this.paging,
                    sorting: this.paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.paginate)
                };
                this.totalRecord = res.data.paginate.totalRecord;
                return true;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    *getDetailInvoice(id) {
        try {
            return yield this.rootStore.apiStore.call(this.api, this.api.getInvoice, id, { hideLoading: true });
        } catch (error) {
            return false;
        }
    }

    *checkInvoiceStatus(payload) {
        try {
            return yield this.rootStore.apiStore.call(this.api, this.api.checkStatusInvoices, payload);
        } catch (error) {
            return false;
        }
    }
}
